function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconnewdoc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.481,
    height: 13.932,
    viewBox: "0 0 12.481 13.932",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7 2v13.351h7.847a2.88 2.88 0 0 0 1.731.581 2.9 2.9 0 0 0 .871-5.67V5.943L13.506 2zm.58.58h5.52v3.774h3.773v3.788c-.1-.01-.192-.015-.29-.015a2.911 2.911 0 0 0-2.9 2.9 2.881 2.881 0 0 0 .588 1.741H7.58zm6.1.41 2.782 2.782h-2.786zM9.032 7.515V8.1h6.385v-.58zm0 1.741v.58h6.385v-.58zm7.546 1.451a2.322 2.322 0 1 1-2.322 2.322 2.329 2.329 0 0 1 2.322-2.322zM9.032 11v.58h3.193V11zm7.546.319a.274.274 0 0 0-.29.29v1.132h-1.132a.29.29 0 0 0 0 .58h1.132v1.132a.29.29 0 1 0 .58 0V13.32H18a.29.29 0 0 0 0-.58h-1.132v-1.133a.274.274 0 0 0-.29-.29z",
    transform: "translate(-7 -2)",
    style: {
      fill: "#5a5a5a"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconnewdoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.newdoc.808885a344129f9d5d49e4589a88408d.svg";